const videoPlayer = {
    isPlaying: false,
    videoId: null,
    source: null,
};

export default videoPlayer;
